import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const noDuplicates = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control || !Array.isArray(control['controls'])) return null;

    const values = control['controls'].map(c => c.value?.trim()).filter(Boolean);
    const hasDuplicates = new Set(values).size !== values.length;

    return hasDuplicates ? { duplicateValues: true } : null;
  };
}
